import { useContext } from 'react';
import { IItinerary } from 'common/types';
import { SearchType } from 'contexts/searchParams';
import {
  InternationalContext,
  IInternationalContextState,
} from 'contexts/international';
import { InternationalFilterContext } from 'contexts/internationalFilter';
import {
  IFilterStore,
  clearFilterStorage,
  resetSelected,
  saveFilterStorage,
} from 'list/international/filter/filterStore';
import { useFilterSaveCookies } from './useFilterSave';

const useInternationalFilter = (itinerary: IItinerary[]) => {
  const { orgFlights, setFlightList }: IInternationalContextState =
    useContext(InternationalContext) || {};
  const { filterStore, setFilterStore } = useContext(
    InternationalFilterContext,
  );

  const [save, toggleFilterSave] = useFilterSaveCookies(
    false,
    SearchType.INTERNATIONAL,
  );
  const applyFilter = (_filterStore: IFilterStore) => {
    if (!orgFlights) {
      return;
    }
    setFlightList(orgFlights, _filterStore);
    if (save) {
      saveFilterStorage(_filterStore);
    } else {
      clearFilterStorage();
    }
  };
  const resetFilter = () => {
    const reset = resetSelected(filterStore, itinerary);
    setFilterStore(reset);
    setFlightList(orgFlights, reset);
  };

  return {
    isKeeping: save,
    applyFilter,
    resetFilter,
    toggleKeeping: toggleFilterSave,
  };
};

export default useInternationalFilter;
